<template>
  <div class="card">
    <div class="card-header">
      <h6>Overview</h6>
    </div>
    <div class="card-body row">
      <div class="col-6">Name</div>
      <div class="col-6">{{ data.user.name }}</div>

      <div class="col-6">Total point</div>
      <div class="col-6">{{ data.total.toLocaleString('id-ID') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data',],
}
</script>